import React from 'react';
import { RoomsAndEventSpaceProps } from './RoomsAndEventSpace.types';
import { DesktopRoomsAndEventSpace } from './DesktopRoomsAndEventSpace';
import { MobileRoomsAndEventSpace } from './MobileRoomsAndEventSpace';

export const RoomsAndEventSpace = React.forwardRef<HTMLInputElement, RoomsAndEventSpaceProps>((props, ref) => {
  const { isMobile = false } = props;

  if (isMobile) {
    return <MobileRoomsAndEventSpace {...props} />;
  }

  return <DesktopRoomsAndEventSpace {...props} ref={ref} />;
});
